import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

const proBadgeVariants = cva(
  "badge inline-flex items-center gap-1 text-[10px] font-bold px-2 py-[3px] rounded-[6px] tracking-[0.02em] uppercase",
  {
    variants: {
      variant: {
        lime: "badge-lime bg-lime-subtle text-lime",
        danger: "badge-danger bg-pro-danger-subtle text-[var(--pro-danger-badge-text)]",
        warning: "badge-warning bg-pro-warning-subtle text-[var(--pro-warning-badge-text)]",
        muted: "badge-muted bg-[var(--pro-muted-badge-bg)] text-pro-text-muted",
        success: "badge-success bg-pro-success-subtle text-[var(--pro-success-badge-text)]",
        info: "badge-info bg-pro-info-subtle text-[var(--pro-info-badge-text)]",
      },
    },
    defaultVariants: { variant: "muted" },
  },
);

type ProBadgeVariant = NonNullable<VariantProps<typeof proBadgeVariants>["variant"]>;

interface ProBadgeProps extends VariantProps<typeof proBadgeVariants> {
  className?: string;
  children: React.ReactNode;
}

function ProBadge({ variant, className, children }: ProBadgeProps) {
  return <span className={cn(proBadgeVariants({ variant }), className)}>{children}</span>;
}

export { ProBadge, type ProBadgeProps, type ProBadgeVariant, proBadgeVariants };
